// @core/api/endpoints/task/list_dependencies.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListDependenciesResponse,
} from '../../../types/task';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/task';

/**
 * List dependencies
 * Returns all dependency relationships for a task, including both tasks this one depends on and tasks that depend on it.
 */
export async function ListDependencies(
  task_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListDependenciesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/dependencies`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  const requestOptions = options;
  return client.get<ListDependenciesResponse>(requestPath, { ...requestOptions, params });
}
